export const keyboardSetup = {
    layouts: [
        ['QWERTYUIOP[Close]',
         'ASDFGHJKL[Del]',
         'ZXCVBNM[Spc]',],

        ['0123456',
         '789[10][11][12]',
         '[13][14][15][16][17][18][19]',
         '[20][21][22][23][24][25]',
        ]
    ],

    font: 'Bebas_small',
    fontSize: 48,
    fontColor: 0,
    fontYOffset: 2,

    minButtonWidth: 44,
    minButtonHeight: 46,
    autoSizeButtons: false,
    fixedSizeButtons: true,

    // image ids are texture ids
    buttonBGImgId: 'letter_btn.png',
    buttonBGImgWidth: 44,
    buttonBGImgHeight: 46,
    hideText: false,

    buttonBGImgIdDel: 'kbd_delete_btn.png',
    buttonBGImgDelWidth: 88,
    buttonBGImgDelHeight: 46,
    hideDelText: true,

    buttonBGImgIdSpace: 'kbd_space_btn.png',
    buttonBGImgSpaceWidth: 176,
    buttonBGImgSpaceHeight: 46,
    hideSpaceText: true,

    showCloseButton: false,
    hideCloseText: true,
    buttonBGImgIdClose: 'kbd_close_btn.png',
    buttonBGImgCloseWidth: 44,
    buttonBGImgCloseHeight: 46,

    mainBGImgId: 'keyboard_bg.png',

    showTitle: false,

    edgePadding: 4,
    betweenPadding: 0,
    rowSpacing: 0,
    buttonInnerPadding: 0,
    buttonInnerPaddingTB: 0,
    buttonInnerPaddingLR: 0,

    keyHighlightColour: 0,
    keyHighlightAlpha: 0.3,
};

export const keyboardSetup_Fr = {
    layouts: [
        ['QWERTYUIOP[Close]',
         'ASDFGHJKL[Del]',
         'ZXCVBNM[Spc][Clear]',],
    ],

    font: 'Bebas_small',
    fontSize: 48,
    fontColor: 0,
    fontYOffset: 2,

    minButtonWidth: 44,
    minButtonHeight: 46,
    autoSizeButtons: false,
    fixedSizeButtons: true,

    // image ids are texture ids
    buttonBGImgId: 'letter_btn.png',
    buttonBGImgWidth: 44,
    buttonBGImgHeight: 46,
    hideText: false,

    buttonBGImgIdDel: 'kbd_delete_btn.png',
    buttonBGImgDelWidth: 88,
    buttonBGImgDelHeight: 46,
    hideDelText: true,

    buttonBGImgIdSpace: 'fr_space_btn.png',
    buttonBGImgSpaceWidth: 132,
    buttonBGImgSpaceHeight: 46,
    hideSpaceText: true,

    showCloseButton: false,
    hideCloseText: true,
    buttonBGImgIdClose: 'kbd_close_btn.png',
    buttonBGImgCloseWidth: 44,
    buttonBGImgCloseHeight: 46,

    hideClearText: true,
    buttonBGImgIdClear: 'clearKey_btn.png',
    buttonBGImgClearWidth: 44,
    buttonBGImgClearHeight: 46,

    mainBGImgId: 'keyboard_bg.png',

    showTitle: false,

    edgePadding: 4,
    betweenPadding: 0,
    rowSpacing: 0,
    buttonInnerPadding: 0,
    buttonInnerPaddingTB: 0,
    buttonInnerPaddingLR: 0,

    keyHighlightColour: 0,
    keyHighlightAlpha: 0.3,
};